/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.container {
  flex-basis: 0px;
  flex-grow: 1;
}
.container input {
  position: absolute;
  opacity: 0%;
  height: 0px;
  width: 0px;
}
.button {
  cursor: pointer;
  --tw-border-style: solid;
  border-style: solid;
  border-style: var(--tw-border-style);
  border-width: 1px;
  border-color: var(--color-gray-300, #d4d4d4);
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
  color: var(--color-primary-600);
  border-radius: var(--radius-sm, 0.25rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: calc(var(--spacing, 0.25rem) * 6);
  text-align: center;
}
.container input ~ *:hover, .container input:focus-visible ~ *, .container input:focus ~ *:hover {
  background-color: var(--color-gray-200, #e5e5e5);
  box-shadow: 5px 5px 0px 0px rgba(0, 0, 0, 0.45);
}
.container input:checked ~ .button {
  background-color: var(--color-primary-600);
  border-color: var(--color-primary-600);
  color: var(--color-white, #fff);
}
.container input:checked ~ *:hover, .container input:checked:focus-visible ~ *, .container input:checked:focus ~ *:hover {
  background-color: var(--color-primary-900);
  border-color: var(--color-primary-900);
  box-shadow: 5px 5px 0px 0px rgba(0, 0, 0, 0.45);
}
.icon {
  font-size: var(--text-4xl, 2.25rem);
  line-height: var(--tw-leading, var(--text-4xl--line-height, calc(2.5 / 2.25)));
  display: flex;
  margin-bottom: calc(var(--spacing, 0.25rem) * 2);
}
.text {
  font-size: var(--text-sm, 0.875rem);
  line-height: var(--tw-leading, var(--text-sm--line-height, calc(1.25 / 0.875)));
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-border-style: solid;
      --tw-font-weight: initial;
    }
  }
}
